import clsx from 'clsx';
import React from 'react';

import Folder from './Folder/Folder';

const Folders = (props) => {
  const {
    folders,
    projectId,
    selected,
    breadcrumbsMap,
    parentFolderId = null,
    savedParentFolderId = null,
    parentFolders,
  } = props;

  return (
    <ul
      className={clsx(
        'container--folderList',
        'tw-block',
        'tw-leading-[1] tw-list-none',
        'tw-my-0  tw-mr-0 tw-ml-[1px] tw-p-0',
        parentFolderId && 'tw-overflow-x-[unset]'
      )}
    >
      {folders.map((folder) => {
        return (
          <Folder
            key={`folder_${folder.id}`}
            folder={folder}
            projectId={projectId}
            selected={selected}
            parentFolderId={parentFolderId}
            savedParentFolderId={savedParentFolderId}
            onSelect={props.onSelect}
            breadcrumbsMap={breadcrumbsMap}
            parentFolders={parentFolders}
          />
        );
      })}
    </ul>
  );
};

Folders.defaultProps = {
  folders: [],
};

export default Folders;
